module.exports = __webpack_public_path__ + "img/security-bg.94eaf649.jpg";